import React, { useEffect, useState } from "react";
import "./cok-header-right.m.css";
import HamburgerAndSearch from "../../../../atoms/hamburger-and-search";
import { useSelector } from "react-redux";
import { get } from "lodash";
import CokSigninButton from "./cok-signin-button";
import CokMyAccountButton from "./cok-my-account-button";

function CokHeaderRight() {
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));
  return (
    <>
      <div styleName="row row2">
        {!isUserLogin && isUserLogin !== undefined && isUserLogin !== null ? (
          <CokSigninButton />
        ) : (
          <CokMyAccountButton />
        )}
        <HamburgerAndSearch />
      </div>
    </>
  );
}

export default CokHeaderRight;
